import React from "react";
import RecommendedCourseCard from "./RecommendedCourseCard";
import SectionCarouselNav from "./SectionCarouselNav";
import { useHorizontalCarousel } from "../hooks/useHorizontalCarousel";
import "./RecommendedSection.css";

const RecommendedSection = ({
  title,
  packages = [],
  highlightedAnchorId = null,
  getPackageCardHandlers,
}) => {
  const {
    viewportRef,
    trackRef,
    trackOffset,
    canScrollLeft,
    canScrollRight,
    hasOverflow,
    scrollByPage,
  } = useHorizontalCarousel(packages.length);

  if (!packages.length) return null;

  const sectionTitle = title || "Recommended for you";

  return (
    <section className="dashboard-recommended" aria-label={sectionTitle}>
      <div className="dashboard-recommended__intro">
        <h2 className="dashboard-recommended__title">{sectionTitle}</h2>
        {hasOverflow ? (
          <SectionCarouselNav
            canScrollLeft={canScrollLeft}
            canScrollRight={canScrollRight}
            onPrev={() => scrollByPage(-1)}
            onNext={() => scrollByPage(1)}
            ariaLabel={`${sectionTitle} navigation`}
          />
        ) : null}
      </div>

      <div className="dashboard-recommended__carousel">
        <div ref={viewportRef} className="dashboard-recommended__viewport">
          <div
            ref={trackRef}
            className="dashboard-recommended__track"
            style={{ transform: `translate3d(-${trackOffset}px, 0, 0)` }}
          >
            {packages.map((course) => (
              <RecommendedCourseCard
                key={course.package_id}
                course={course}
                section="recommended"
                highlightedAnchorId={highlightedAnchorId}
                {...getPackageCardHandlers(course)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecommendedSection;
